import FlagIcon from '@mui/icons-material/Flag';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, IconButton } from '@mui/material';
import React from 'react';
import '../../../styles/cssStyles.css';
import { Typography } from '@uhc-tempo/components';
import { CURSOR_POINTER, ENTER_KEY } from '../../../constants';
import { Warning } from '@mui/icons-material';
export default function DisclaimerMessageUtil(props) {
    const { handleCloseIconClick, messageKey, messageValue, dataTestID, isWarningDisclaimer } =
        props;
    const bgColor = isWarningDisclaimer ? '#FEF9EA' : '#E5F8FB';
    return (
        <Box
            component="div"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: bgColor,
                minHeight: '72px',
                marginBottom: '24px',
                paddingLeft: '16px',
                paddingRight: '16px',
            }}
            data-testid={dataTestID}
        >
            <Box>
                <div key={`${dataTestID}-disclaimer-div`}>
                    <Grid
                        container
                        spacing={1}
                        display="flex"
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        wrap="nowrap"
                        sx={{
                            paddingTop: '14px',
                        }}
                    >
                        {isWarningDisclaimer ? (
                            <Grid item sx={{ position: 'relative' }}>
                                <Warning
                                    sx={{
                                        position: 'sticky',
                                        zIndex: '1',
                                    }}
                                    style={{
                                        color: '#F5B700',
                                    }}
                                />
                            </Grid>
                        ) : (
                            <Grid item sx={{ position: 'relative' }}>
                                <FlagIcon
                                    sx={{
                                        position: 'sticky',
                                        zIndex: '1',
                                    }}
                                    style={{
                                        color: '#002677',
                                    }}
                                />{' '}
                            </Grid>
                        )}
                        <Grid item>
                            <Typography.Paragraph
                                data-testid={`${dataTestID}DisclaimerText`}
                                style={{
                                    fontFamily: '"UHC Sans", Arial, sans-serif',
                                    fontStyle: 'Normal',
                                    fontSize: '16px',
                                    lineHeight: '22px',
                                    color: '#5A5A5A',
                                }}
                            >
                                <span
                                    style={{ fontWeight: 700, color: '#323334' }}
                                >{`${messageKey}: `}</span>
                                {messageValue}
                            </Typography.Paragraph>
                        </Grid>
                    </Grid>
                </div>
            </Box>
            <IconButton
                style={{ cursor: CURSOR_POINTER, color: '#333333' }}
                tabIndex={0}
                aria-label={`close${dataTestID}Disclaimer`}
                sx={{
                    '&:focus': {
                        outline: '#196ecf auto 1px',
                    },
                }}
                onClick={() => {
                    handleCloseIconClick();
                }}
                onKeyDown={(e) => {
                    if (e.key == ENTER_KEY || e.key == ' ') {
                        handleCloseIconClick();
                    }
                }}
            >
                <CloseIcon />
            </IconButton>
        </Box>
    );
}
